import React from 'react';
import { useMetaTags } from '../hooks/useMetaTags';
export function CANoticePage() {
  useMetaTags({
    title: 'CA Notice at Collection | FindOnlineDegrees',
    description: 'California Consumer Privacy Act notice for FindOnlineDegrees.org'
  });
  return <div className="min-h-screen bg-gray-100" data-id="element-479">
      {/* Hero Section */}
      <section className="w-full bg-[#1a2332] text-white py-16 px-4" data-id="element-480">
        <div className="max-w-4xl mx-auto text-center" data-id="element-481">
          <h1 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-482">
            CA Notice At Collection
          </h1>
          <p className="text-gray-300 text-sm" data-id="element-483">Last updated: January 2026</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="max-w-4xl mx-auto px-4 py-12" data-id="element-484">
        <div className="bg-white rounded-lg shadow-sm p-8 md:p-12 space-y-8" data-id="element-485">
          <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-486">
            <p data-id="element-487">
              This privacy notice for FindOnlineDegrees.org describes how and
              why we might collect, store, use, and/or share your information
              when you use our services, such as when you:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-488">
              <li data-id="element-489">
                Visit our website, or any website of ours that links to this
                privacy notice
              </li>
              <li data-id="element-490">
                Engage with us in other related ways, including any sales,
                marketing, or events
              </li>
            </ul>
            <p className="font-semibold" data-id="element-491">
              Questions or concerns? Reading this privacy notice will help you
              understand your privacy rights and choices. If you do not agree
              with our policies and practices, please do not use our services.
            </p>
          </div>

          <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-492">
            <p data-id="element-493">
              If you are a California resident, the California Consumer Privacy
              Act ("CCPA") requires us to provide you with the following notice
              with information about:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-494">
              <li data-id="element-495">
                the purpose for which we use each category of "personal
                information" (as defined in the CCPA) we collect; and
              </li>
              <li data-id="element-496">
                the categories of third parties to which we (a) disclose such
                personal information for a business purpose, (b) "share"
                personal information for "cross-context behavioral advertising,"
                and/or (c) "sell" such personal information.
              </li>
            </ul>
          </div>

          {/* Categories of Personal Information */}
          <div data-id="element-497">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-498">
              Categories of Personal Information We Collect
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-499">
              <p data-id="element-500">
                The table below describes the categories of personal information
                we have collected from California consumers in the preceding 12
                months, the sources from which we collected it, our business or
                commercial purposes for collecting it, and the categories of
                third parties to whom we disclose, share, or sell that
                information.
              </p>
            </div>

            <div className="overflow-x-auto mt-6" data-id="element-501">
              <table className="min-w-full border border-gray-300" data-id="element-502">
                <thead className="bg-gray-50" data-id="element-503">
                  <tr data-id="element-504">
                    <th className="border border-gray-300 px-4 py-3 text-left text-sm font-semibold text-gray-900" data-id="element-505">
                      Category of Personal Information
                    </th>
                    <th className="border border-gray-300 px-4 py-3 text-left text-sm font-semibold text-gray-900" data-id="element-506">
                      Examples
                    </th>
                    <th className="border border-gray-300 px-4 py-3 text-left text-sm font-semibold text-gray-900" data-id="element-507">
                      Collected?
                    </th>
                    <th className="border border-gray-300 px-4 py-3 text-left text-sm font-semibold text-gray-900" data-id="element-508">
                      Sources
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white" data-id="element-509">
                  <tr data-id="element-510">
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-511">
                      <strong data-id="element-512">Identifiers</strong>
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-513">
                      Name, email address, phone number, IP address, device ID
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-514">
                      Yes
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-515">
                      Directly from you via forms, automatically via cookies
                    </td>
                  </tr>
                  <tr className="bg-gray-50" data-id="element-516">
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-517">
                      <strong data-id="element-518">Personal Information (CA Civil Code)</strong>
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-519">
                      Name, contact information, education history
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-520">
                      Yes
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-521">
                      Directly from you via forms
                    </td>
                  </tr>
                  <tr data-id="element-522">
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-523">
                      <strong data-id="element-524">Commercial Information</strong>
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-525">
                      Records of services considered or obtained
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-526">
                      Yes
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-527">
                      From your interactions with our services
                    </td>
                  </tr>
                  <tr className="bg-gray-50" data-id="element-528">
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-529">
                      <strong data-id="element-530">Internet/Network Activity</strong>
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-531">
                      Browsing history, search history, interaction with website
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-532">
                      Yes
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-533">
                      Automatically via cookies and analytics
                    </td>
                  </tr>
                  <tr data-id="element-534">
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-535">
                      <strong data-id="element-536">Geolocation Data</strong>
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-537">
                      Approximate location based on IP address
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-538">
                      Yes
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-539">
                      Automatically via IP address
                    </td>
                  </tr>
                  <tr className="bg-gray-50" data-id="element-540">
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-541">
                      <strong data-id="element-542">Inferences</strong>
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-543">
                      Preferences, characteristics, behavior
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-544">
                      Yes
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-545">
                      Derived from your activity on our services
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Business Purposes */}
          <div data-id="element-546">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-547">
              Business or Commercial Purposes for Collection
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-548">
              <p data-id="element-549">
                We collect and use personal information for the following
                purposes:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-550">
                <li data-id="element-551">To provide, improve, and administer our services</li>
                <li data-id="element-552">
                  To communicate with you, including responding to inquiries
                </li>
                <li data-id="element-553">To ensure security and fraud prevention</li>
                <li data-id="element-554">To comply with legal obligations</li>
                <li data-id="element-555">To deliver targeted advertising and marketing</li>
                <li data-id="element-556">To analyze and improve our website performance</li>
                <li data-id="element-557">To connect you with educational institutions</li>
              </ul>
            </div>
          </div>

          {/* Disclosure of Personal Information */}
          <div data-id="element-558">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-559">
              Disclosure of Personal Information
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-560">
              <p data-id="element-561">
                We may disclose your personal information to the following
                categories of third parties:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-562">
                <li data-id="element-563">Educational institutions and their partners</li>
                <li data-id="element-564">Service providers (analytics, hosting, marketing)</li>
                <li data-id="element-565">Advertising partners and networks</li>
                <li data-id="element-566">Legal and regulatory authorities when required</li>
                <li data-id="element-567">Business partners in connection with business transfers</li>
              </ul>
            </div>
          </div>

          {/* Your Rights */}
          <div data-id="element-568">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-569">
              Your California Privacy Rights
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-570">
              <p data-id="element-571">As a California resident, you have the following rights:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-572">
                <li data-id="element-573">
                  <strong data-id="element-574">Right to Know:</strong> Request disclosure of the
                  categories and specific pieces of personal information we have
                  collected about you.
                </li>
                <li data-id="element-575">
                  <strong data-id="element-576">Right to Delete:</strong> Request deletion of your
                  personal information, subject to certain exceptions.
                </li>
                <li data-id="element-577">
                  <strong data-id="element-578">Right to Correct:</strong> Request correction of
                  inaccurate personal information.
                </li>
                <li data-id="element-579">
                  <strong data-id="element-580">Right to Opt-Out:</strong> Opt out of the "sale" or
                  "sharing" of your personal information for cross-context
                  behavioral advertising.
                </li>
                <li data-id="element-581">
                  <strong data-id="element-582">Right to Limit:</strong> Limit the use and disclosure
                  of sensitive personal information (if applicable).
                </li>
                <li data-id="element-583">
                  <strong data-id="element-584">Right to Non-Discrimination:</strong> You will not
                  receive discriminatory treatment for exercising your privacy
                  rights.
                </li>
              </ul>
            </div>
          </div>

          {/* How to Exercise Rights */}
          <div data-id="element-585">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-586">
              How to Exercise Your Rights
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-587">
              <p data-id="element-588">
                To exercise your rights under the CCPA, please contact us
                through the information provided on our website. We will verify
                your identity before processing your request and respond within
                the timeframes required by law.
              </p>
            </div>
          </div>

          {/* Contact Us */}
          <div data-id="element-589">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-590">
              Contact Us
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-591">
              <p data-id="element-592">
                If you have questions about this notice or wish to exercise your
                California privacy rights, please contact us through the
                information provided on our website.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}